import ApiService from "../api";

export default class UsuarioService extends ApiService {

    constructor() {
        super('/api/usuarios')
    }

    autenticar(credentials) {
        return this.post(`/autenticar`, credentials)
    }

    alterarSenha(alterarSenha) {
        return this.post(`/alterar-senha`, alterarSenha)
    }

    buscarUsuario(id) {
        return this.get(`/${id}`)
    }

    listarUsuarios() {
        return this.get(``)
    }

    listarUsuariosMydashSolicitacao() {
        return this.get(`/possui-mydash-solicitacao`)
    }

    listarUsuariosDiretores() {
        return this.get(`/diretores`)
    }

    listarUsuariosPaginado(params) {
        return this.get(`/page?size=200`)
    }

    cadastrarUsuario(dados) {
        return this.post(``, dados)
    }

    cadastroUsuarioPeloDiretor(dados) {
        return this.post(`/cadastro-pelo-diretor`, dados)
    }

    atualizarUsuario(id, usuario) {
        return this.put(`/${id}`, usuario)
    }

    excluirUsuario(id) {
        return this.delete(`/${id}`)
    }

    ativarOuDesativar(id) {
        return this.put(`/ativar-desativar/${id}`)
    }

    atualizarAcessoMydash(id, valor) {
        return this.put(`/${id}/acesso-mydash?valor=${valor}`)
    }

    atualizarAcessoMydashSolicitacoes(id, valor) {
        return this.put(`/${id}/acesso-mydash-solicitacoes?valor=${valor}`)
    }

    atualizarFuncionario(id, funcionarioId) {
        const query = funcionarioId ? `?funcionarioId=${encodeURIComponent(funcionarioId)}` : "";
        return this.put(`/${id}/funcionario${query}`)
    }

    resetarSenha(id) {
        return this.put(`/resetar-senha/${id}`)
    }

    listarSessoes(id) {
        return this.get(`/${id}/sessoes`)
    }

    revogarSessao(sessaoId) {
        return this.delete(`/sessoes/${sessaoId}`)
    }

    revogarTodasSessoes(id) {
        return this.delete(`/${id}/sessoes`)
    }

    solicitarResetSenha(email) {
        return this.put(`/solicitar-reset-senha/${email}`);
    }

    redefinirSenha(dto) {
        return this.put(`/redefinir-nova-senha/${dto.email}`, dto);
    }
}